import GeoJSON from 'ol/format/GeoJSON';
import Map from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import View from 'ol/View';
import {Fill, Stroke, Style} from 'ol/style';
import Overlay from 'ol/Overlay';
import {fromLonLat} from 'ol/proj';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import ol from 'ol';
import Interaction from 'ol/interaction/Interaction';
import 'ol/ol.css';
import Collection from 'ol/Collection';
import {defaults} from 'ol/interaction/defaults';

document.addEventListener("DOMContentLoaded", function () {
    const interactions = new defaults({
        mouseWheelZoom: false,
        onFocusOnly: true,
    });
    const style = new Style({
        fill: new Fill({
            color: '#EDEDED',
        }),
        stroke: new Stroke({
            color: '#EDEDED',
            width: 1
        }),
    });

    const styles = {
        default: new Style({
            fill: new Fill({
                color: '#CCCCCC',
            }),
            stroke: new Stroke({
                color: '#FFFFFF',
                width: 1
            }),
        }),
        hover: new Style({
            fill: new Fill({
                color: 'rgba(0,255,0,.4)',
            }),
            stroke: new Stroke({
                color: '#0f0',
                width: 2
            }),
        }),
        active: new Style({
            fill: new Fill({
                color: '#255076',
            }),
            stroke: new Stroke({
                color: '#FFFFFF',
                width: 1
            }),
        })
    }

    const vectorLayer = new VectorImageLayer({
        imageRatio: 2,
        source: new VectorSource({
            url: 'https://raw.githubusercontent.com/simp37/Russia_geoJSON/master/Russia.geojson',
            format: new GeoJSON(),
        }),
        style: function (feature) {
            const color = '#255076';
            if(feature.get('cartodb_id') === 8 ||
                feature.get('cartodb_id') === 7 ||
                feature.get('cartodb_id') === 11 ||
                feature.get('cartodb_id') === 67 ||
                feature.get('cartodb_id') === 68) {
                style.getFill().setColor(color);
            } else {
                const newColor = '#CCCCCC';

                style.getFill().setColor(newColor);
            }

            return style;
        },
    });

    const map = new Map({
        layers: [
            // new TileLayer({
            //     source: new OSM()
            // }),
            vectorLayer],
        target: 'map',
        interactions: interactions,
        view: new View({
            center: [16365196, 9806840],
            zoom: 4.4,
            maxZoom: 5,
            minZoom: 1,
            extent: [
                ...fromLonLat([22.044321, 15.782652]),
                ...fromLonLat([200.518731, 82.735876]),
            ],
            showFullExtent: true,
        }),
        
    });

    //убираем скролл на карте
    const mouseWheelInt = new MouseWheelZoom();
    map.addInteraction(mouseWheelInt);
    mouseWheelInt.setActive(!mouseWheelInt.getActive())

    const json = require('./dots.json');
    const data = JSON.stringify(json);
    const dataJson = JSON.parse(data);

    dataJson.map((item, index) => {
        setDots(item, (item.location).split(','), index)
    })

    function setDots(item, location, index) {
        let dot = document.createElement('div')
        dot.className = 'marker marker' + Number(index);
        let popup = document.createElement('div');
        popup.className = 'ol-popup';

        let title = document.createElement('h5');
        title.innerHTML = item.title;
        popup.appendChild(title);
        item.links.forEach((link) => {
            let url = document.createElement('a');
            if (link.text && link.address) {
                url.setAttribute("href", link.address);
                url.setAttribute("target", "_blank");
                url.innerHTML = link.text;
                popup.appendChild(url);
            }
        })

        const places = item.places;

        places.forEach((place) => {
            let text = document.createElement('p');
            if (place.text) {
                text.innerHTML = place.text;
                popup.appendChild(text);
            }
        })

        dot.appendChild(popup);

        map.addOverlay(
            new Overlay({
                position: fromLonLat(location),
                positioning: 'bottom-center',
                element: dot,
            })
        );
    }

    const markers = document.querySelectorAll('.marker');

    markers.forEach(function (marker) {
        if (marker) {
            marker.classList.remove('show')
            marker.addEventListener('click', (event) => {
                markers.forEach(function (marker) {
                    marker.classList.remove('show')
                })
                marker.classList.add('show')
            })
        }
    })
    const olContainer = document.querySelectorAll('.ol-overlay-container');
    olContainer.forEach(function (marker) {
        if (marker) {
            marker.classList.remove('show')
            marker.addEventListener('click', (event) => {
                olContainer.forEach(function (marker) {
                    marker.classList.remove('show')
                })
                marker.classList.add('show')
            })
        }
    })

    document.addEventListener('click', function (evt) {
        if(evt.target.closest('.ol-popup') || evt.target !== evt.target.closest('.marker')) {
            markers.forEach(function (marker) {
                marker.classList.remove('show')
            })
        }
    });

    map.addEventListener('mousemove', function (event) {
        console.log('event')
    });

    const mediaQuery = window.matchMedia('(max-width: 767.98px)');

    if (mediaQuery.matches) {
        console.log('меньше 768')
        map.getView().animate({
            zoom: map.getView().getZoom() - 1.8,
            duration: 250
        })
    }
});
